import changeCase from 'change-case'
import { array, func, string, bool, oneOf } from 'prop-types'
import { Button, WithTooltip } from '@opallabs/kuiper'
import './styles.scss'

const AddComponentButton = ({
  ariaLabel = 'Add New Component',
  buttonDisabled = false,
  hasMenu,
  iconSize = 'normal',
  label,
  onClick,
  onSelect,
  options,
  postType = '',
  service = '',
  tooltip,
}) => (
  <WithTooltip
    content={tooltip}
    className={`add-component-button-tooltip ${changeCase.paramCase(
      service
    )} ${changeCase.paramCase(postType)}`}
    disabled={!tooltip || !buttonDisabled}
    tooltipOptions={{ position: 'top' }}
  >
    <Button
      ariaLabel={ariaLabel}
      className="add-component"
      disabled={buttonDisabled}
      hasMenu={hasMenu}
      icon="plus-solid"
      menuClassName={`add-component-menu ${changeCase.paramCase(service)}`}
      onClick={onClick}
      onSelect={onSelect}
      options={options}
      overscanCount={3}
      position="left"
      label={label}
      noArrow={true}
      rowHeight={iconSize === 'large' ? 48 : 27}
      type="secondary"
    />
  </WithTooltip>
)

AddComponentButton.propTypes = {
  ariaLabel: string,
  buttonDisabled: bool,
  hasMenu: bool,
  iconSize: oneOf(['normal', 'large']),
  label: string,
  onClick: func,
  onSelect: func,
  options: array,
  postType: string,
  service: string,
  tooltip: string,
}

export default AddComponentButton
